export default class GoogleMapApi {
    constructor(apiKey, defaultLocation) {
        this.apiKey = apiKey
        this.defaultLocation = defaultLocation
    }

    async getPredictions(value) {
        const pattern = new RegExp("[^A-Za-z][0-9]*")
        
        const type = value.length <= 5 && pattern.exec(value)
            ? "postal_code"
            : "address"
        
        const response = await axios.get(`/api/place/autocomplete/json?input=${value}&types=${type}&location=${this.defaultLocation}&radius=500&key=${this.apiKey}`)

        return response.data.predictions.slice(0, 3)
    }

    async getLocation(placeId){
        const response = await axios.get(`/api/geocode/json?place_id=${placeId}&key=${this.apiKey}`);

        return response.data.results[0].geometry.location
    }

    async getAddress(location){
        const response = await axios.get(`/api/geocode/json?latlng=${location}&key=${this.apiKey}`);

        return response.data.results[0].formatted_address
    }
}
